export function ascSortFilesByParam (files, sortBy) {
  if (files?.length > 0) {
    return files.sort((a, b) => (a[sortBy]?.toLowerCase() > b[sortBy]?.toLowerCase())
      ? 1 : (b[sortBy]?.toLowerCase() > a[sortBy]?.toLowerCase() ? -1 : 0))
  }
  return []
}